<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <div class="mb-2 btn-new">
          <GeneratePDF :show-quantidade="true" :items="headersPdf" :list="listForPDF" :options="optionsPDF" :orderByProps="'nome'"/>
          <v-btn
            color="#27997c"
            dark
            class="mb-2 ml-2"
            @click="openDialog = !openDialog"
            v-on="on"
          >
          <v-icon>mdi-plus</v-icon>
            Adicionar Novo
          </v-btn>
        </div>
        <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Listagem de Pessoas</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-select
                class="mr-2"
                v-model="filter.inativo"
                :items="opcoesInativos"
                :item-text="'nome'"
                :item-value="'id'"
                dense
                outlined
                label="Status"
              ></v-select>
              <v-text-field
                v-model="search"
                dense
                outlined
                label="Buscar"
                append-icon="mdi-magnify"
              ></v-text-field>

            </v-toolbar>
          </template>
          <template v-slot:item.salario="{ item }">
            {{ item.salario | localCurrency }}
          </template>
          <template v-slot:item.chave_pix="{ item }">
            <div style="white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;">{{ item.chave_pix }}</div>
          </template>
          <template v-slot:item.isInativo="{ item }">

            <v-chip
              class="ma-2 white--text"
              :color="item.isInativo === true ? 'red':'primary'"
            >
              {{item.isInativo === true ? 'Inativo':'Ativo'}}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              small
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="red"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <span>Sem dados disponíveis</span>
        </template>
        </v-data-table>
        <AddModalVue :openDialog="openDialog" @closeModal="closeModal" />
        <EditModal :objValue="objEdit" :dialogEdit="dialogEdit" @closeEditItem="closeEditItem" />
        <DeleteModal :dialogDelete="dialogDelete" :objValue="objEdit" @deleteItemConfirm="deleteItemConfirm" @closeDelete="closeDelete" @closeDeleteItem="closeDeleteItem" />
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import GeneratePDF from '@/components/utils/GeneratePDF.vue';
import { mapGetters, mapActions } from 'vuex';
import AddModalVue from './AddModal.vue'
import EditModal from './EditModal.vue'
import DeleteModal from './DeleteModal.vue'
  export default {
    components:{
    PageWrapper,
    PageContent,
    AddModalVue,
    EditModal,
    DeleteModal,
    GeneratePDF
  },
    data: () => ({
      search:'',
      openDialog: false,
      dialogEdit:false,
      dialogDelete: false,
      loading:false,
      objEdit:{},
      filter:{},
      opcoesInativos:[
        {
          nome: 'Todos',
          id: null
        },,
        {
          nome: 'Inativo',
          id: true
        },
        {
          nome: 'Ativo',
          id: false
        }
      ],
      headers: [
        { text: 'Nome', value: 'nome',  sortable: false,  align: 'start', sortable: true, },
        {
          text: 'CPF',
          align: 'start',
          sortable: true,
          value: 'CPF',
        },
        { text: 'Status', value: 'isInativo',  sortable: false,  align: 'start', },
        { text: 'Chave Pix', value: 'chave_pix',  sortable: false,  align: 'start', },
        { text: 'Salário', value: 'salario',  sortable: false,  align: 'start',  },
        { text: 'Telefone', value: 'telefone',  sortable: false,  align: 'start',  },
        { text: 'Ações', value: 'actions', sortable: false, align: 'start',  },
      ],
      headersPdf: [
        {
          text: 'Nome',
          align: 'center',
          sortable: true,
          value: 'nome',
          class: 'text-uppercase fontsPrimaryVariant--text background darken-2',
        },
        {
          text: 'Cpf',
          align: 'center',
          sortable: true,
          value: 'CPF',
          class: 'text-uppercase fontsPrimaryVariant--text background darken-2',
        },
        {
          text: 'Chave Pix',
          align: 'center',
          sortable: true,
          value: 'chave_pix',
          class: 'text-uppercase fontsPrimaryVariant--text background darken-2',
        },
        {
          text: 'Salário',
          align: 'center',
          sortable: true,
          value: 'salario',
          class: 'text-uppercase fontsPrimaryVariant--text background darken-2',
        },
        {
          text: 'Telefone',
          align: 'center',
          sortable: true,
          value: 'telefone',
          class: 'text-uppercase fontsPrimaryVariant--text background darken-2',
        }
      ],
      optionsPDF: {
        title: 'Relatório de Pessoas',
        docName: 'pessoas'
      },
      pessoas: [],
      editedIndex: -1,
    }),
    computed: {
      ...mapGetters('pessoa',['getList']),
      listForPDF(){
        return this.filteredList.map((item)=>{
          return {
            ...item,
            salario: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.salario),
          }
        })
      },
      filteredList(){
        return this.getList.filter((item) => {
          if(this.filter.inativo === null){
            return true;
          }
          
          if(item.isInativo === undefined && !this.filter.inativo){
            return true;
          }

          return this.filter.inativo === item.isInativo
        })
      }
    },
    async created () {
       await this.getAllPessoas()
    },
    methods: {
      ...mapActions('pessoa', ['getAllPessoas']),
      initialize () {
        this.pessoas = ['']
      },
      deleteItem (item) {
        this.objEdit = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.getList.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      editItem (item) {
          this.objEdit = Object.assign({}, item)
          this.dialogEdit = true
        },
      closeDelete () {
         this.dialogDelete = false;
      },
      closeDeleteItem () {
        this.dialogDelete = false;
        this.getAllPessoas ()
      },
      closeEditItem (reload) {
        if(reload){
          this.getAllPessoas ()
        }
         this.dialogEdit = false;
      },
      closeModal () {
        this.openDialog = false;
      },
      close () {
        this.dialog = true
      }
    }
  }
</script>

<style>

.menu {
  width: 80%;
  padding-top: 70px;
  position: absolute;
}
.btn-new{
  margin-right: 24px;
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #272727;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>
